export default "__VITE_ASSET__Du1S04IA__"